
import {Vue, Component, Prop, Emit} from 'vue-property-decorator';
import {materiaApi} from '@/api';

@Component
export default class Student_Course_Class extends Vue {
    @Prop({default: []}) record?: any;
    @Emit('closeModal') private closeModal() {}
    //===================================data区域begin
    courseId: string = '';
    classNum: number = 0;
    classList: any = [];
    columns: any = [
        {
            dataIndex: 'className',
            title: '班级名称',
            width: '50%',
            scopedSlots: {
                customRender: 'className'
            }
        },
        {
            dataIndex: 'associatedType',
            title: '班级来源',
            width: '50%',
            customRender: (text: any) => {
                if (text == 'byAdmin') {
                    return '学校管理员关联';
                } else if (text == 'byTeacher') {
                    return '教师手动添加';
                }
            }
        }
    ];
    pager: any = {
        pagesize: 10,
        pagenum: 1,
        total: 0,
        rows: []
    };
    loading: boolean = false;
    scrollTop: any = [];
    allPagenum: number = 0;
    //===================================data区域end
    //===================================computed区域begin
    //===================================computed区域end
    //===================================methods区域begin
    handleCancel() {
        this.$emit('closeModal');
    }
    getInfo() {
        let me = this;
        me.loading = true;
        let data = {
            courseId: me.courseId,
            page: this.pager.pagenum,
            pagesize: this.pager.pagesize
        };
        materiaApi.getcheckboxGroupAndcheckAll({
            context: me,
            data: data,
            success(data: any) {
                let dataList = data.data.list;
                if (data.data.total > 0) {
                    if (me.pager.pagenum > 1) {
                        me.classList = me.classList.concat(dataList);
                    } else {
                        me.classList = dataList;
                    }
                    me.classNum = data.data.total;
                    me.allPagenum = data.data.pageCount;
                }
                me.loading = false;

                // 滚动加载
                me.scrollTop = document.querySelector('.content');
                me.scrollTop.addEventListener('scroll', (e: any) => {
                    let scrollTop = e.target.scrollTop;
                    let clientHeight = e.target.clientHeight;
                    let scrollHeight = e.target.scrollHeight;
                    if (scrollTop + clientHeight === scrollHeight && me.allPagenum !== me.pager.pagenum) {
                        me.pager.pagenum++;
                        me.getInfo();
                    }
                });
            },
            error(error: any, message: string) {
                me.$message.error(message);
                me.loading = false;
            }
        });
    }
    //===================================methods区域end
    created() {
        if (this.record) {
            this.courseId = this.record.courseId;
        }
        this.getInfo();
    }
    mounted() {}
    beforeDestroy() {
        this.scrollTop.removeEventListener('scroll', () => {
            console.log('移除了滚动加载');
        });
    }
}
